import { array, date, object, string } from "yup"
import {
  email as mail,
  firstName,
  ID,
  lastName,
  phoneNumber as phone,
} from "../yup.common"

export default object({
  id: ID,
  firstName: firstName,
  lastName: lastName,
  username: string()
    .min(2, "Username should be atleast 2 characters!")
    .max(60, "Username should not exceed 60 characters!")
    .required("Username is required!"),
  number: phone.required("Phone Number is required!"),
  email: mail.nullable(),
  dateOfBirth: date()
    .label("Date Of Birth")
    .required("Please enter a valid date of birth!"),
  departments: array().label("Departments"),
  groups: array().label("Departments"),
  customerId: string().required("Please enter a valid customer ID"),
  metadata: object({
    secondaryNumber: phone.nullable(),
  }),
})
